import { render, staticRenderFns } from "./WakaTimes.vue?vue&type=template&id=7fbf8ab8&"
import script from "./WakaTimes.vue?vue&type=script&lang=js&"
export * from "./WakaTimes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports